import { lazy } from 'react';
import AIBuilder from './pages/AIBuilder';
import Academy from './pages/Academy';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQs from './pages/FAQs';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import SEO from './pages/SEO';

import Team from './pages/Team';
import Pricing from './pages/Pricing';
import Invest from './pages/Invest';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import DataCompliance from './pages/DataCompliance';
import Verdict from './pages/Verdict';
import Partnership from './pages/Partnership';
import Affiliate from './pages/Affiliate';
import Templates from './pages/Templates';
import AffiliateTnC from './pages/AffiliateTnC';
import AcceptableUsePolicy from './pages/AcceptableUsePolicy';
import Changelog from './pages/Changelog';
import Status from './pages/Status';
import Services from './pages/Services';
import CustomBuilds from './pages/CustomBuilds';
import RefundPolicy from './pages/RefundPolicy';
import Marketplace from './pages/Marketplace';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Settings   = lazy(() => import('./pages/Settings'));
const Admin      = lazy(() => import('./pages/Admin'));

import __Layout from './Layout.jsx';


export const PAGES = {
    "AIBuilder": AIBuilder,
    "Academy": Academy,
    "About": About,
    "Contact": Contact,
    "FAQs": FAQs,
    "Home": Home,
    "Portfolio": Portfolio,
    "SEO": SEO,

    "Team": Team,
    "Pricing": Pricing,
    "Dashboard": Dashboard,
    "Settings": Settings,
    "Admin": Admin,
    "Invest": Invest,
    "PrivacyPolicy": PrivacyPolicy,
    "TermsOfUse": TermsOfUse,
    "DataCompliance": DataCompliance,
    "Verdict": Verdict,
    "Partnership": Partnership,
    "Affiliate": Affiliate,
    "Templates": Templates,
    "AffiliateTnC": AffiliateTnC,
    "AcceptableUsePolicy": AcceptableUsePolicy,
    "Changelog": Changelog,
    "Status": Status,
    "Services": Services,
    "CustomBuilds": CustomBuilds,
    "RefundPolicy": RefundPolicy,
    "Marketplace": Marketplace,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};